module.exports = "\n<div style=\"text-align: center\">\n  <img src=\"assets/images/coming-soon.png\" alt=\"\" width=\"40%\">\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/devotee/coming-soon/coming-soon.component.html
// module id = ./src/app/devotee/coming-soon/coming-soon.component.html
// module chunks = main